/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Tablet Landscape",
  size: 20
}

const SvgTabletLandscape = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      d="M1.5 5c0-.8.7-1.5 1.5-1.5h14c.8 0 1.5.7 1.5 1.5v11c0 .8-.7 1.5-1.5 1.5H3c-.8 0-1.5-.7-1.5-1.5V5h0z"
    />
    <circle cx={3.7} cy={10.5} r={0.8} />
  </Svg>
)

SvgTabletLandscape.defaultProps = defaultProps
export default SvgTabletLandscape
